<template>
  <div class="columns is-align-items-center">
    <div class="column is-8">
      <div style="width: 400px;height: 400px;">
        <line-chart
          v-if="(addChartData && addChartData.datasets[0].data.length) || (this.line_chart.selectable_answers && this.line_chart.selectable_answers.length) "
          :chartData="addChartData"
          :extraOptions="addExtraOptions"
          :extraData="extraData"
          @userCoordinate="receiveUserCoord"
        ></line-chart>
      </div>
    </div>
    <div class="column is-4">
     <show-line-chart-legend
        v-if="line_chart.is_legend"
        :data="line_chart.properties"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import LineChart from "../../Charts/LineChart";
import ShowLineChartLegend from './ShowLineChartLegend.vue';

export default {
  name: "show-line-chart",
  components: {
    LineChart,
    ShowLineChartLegend
  },
  props: {
    line_chart: {
      type: Object,
    },
  },
  data() {
    return {
      user_selectable_coord: [],
    };
  },
  computed: {
    addChartData() {
      let chartData = {
        labels : [],
        datasets: [
          {
            lineTension: this.line_chart.is_curved? 0.3 : 0,
            borderColor: this.line_chart.line_border_color,
            pointRadius: this.line_chart.point_radius,
            backgroundColor: "#f87979",
            data: [],
            fill: false,
            borderWidth: this.line_chart.is_show_lines ? 3 : 0,
            showLine: this.line_chart.is_show_lines,
          },
        ],
        images: [],
        is_user_select_points: this.line_chart.is_user_select_points,
      };

      if (this.line_chart.properties.length) {
        for (let point of this.line_chart.properties) {
          if (point.clipart && point.clipart.clipart) {
            chartData.images.push({
              file: point.clipart.clipart.file,
              width: point.clipart.width,
              height: point.clipart.height,
            });
          } else {
            chartData.images.push(null);
          }
          
          // If custom labels, check if the label already exists
          if(this.line_chart.is_custom_x_labels){
            if(!chartData.labels.includes(point.x_coordinate)){
              chartData.labels.push(point.x_coordinate);
            }
          }

          chartData.datasets[0].data.push({
            x: point.x_coordinate,
            y: point.y_coordinate,
          });
        }
      }

      if(this.line_chart.is_custom_x_labels){
        for (let point of this.line_chart.selectable_answers) {
          if(!chartData.labels.includes(point.x)){
              chartData.labels.push(point.x);
          }
        }
      }

      return chartData;
    },
    addExtraOptions() {
      let extraOptions = {
        animation: false,
        title: {
          display: true,
          text: this.line_chart.title,
          fontStyle: this.line_chart.is_title_bold ? "bold" : "normal",
          fontSize: 20,
        },
        responsive: false,
        maintainAspectRatio: true,
        scales: {
          yAxes: [
            {
              type: "linear",
              ticks: {
                padding: 20,
                fontColor: "#000",
                min: this.line_chart.min_y_value,
                suggestedMax: this.line_chart.max_y_value,
                stepSize: this.line_chart.step_y_size,
              },
              scaleLabel: {
                display: true,
                labelString: this.line_chart.y_title ? this.line_chart.y_title : "Y",
                fontStyle:  "bold",
                fontSize: 16
              }
            },
          ],
          xAxes: [
            {
              // type: "linear",
              ticks: {
                padding: 20,
                fontColor: "#000",
                min: this.line_chart.min_x_value,
                suggestedMax: this.line_chart.max_x_value,
                stepSize: this.line_chart.step_x_size,
              },
              scaleLabel: {
                display: true,
                labelString: this.line_chart.x_title ? this.line_chart.x_title : "X",
                fontStyle:  "bold",
                fontSize: 16
              }
            },
          ],
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: false,
        },
      };

      if(!this.line_chart.is_custom_x_labels){
        extraOptions['scales']['xAxes'][0]['type'] = "linear"
      }
      return extraOptions;
    },
    extraData(){
      let extra_data = {
        is_custom_x_labels : this.line_chart.is_custom_x_labels,
        is_allow_single_selection : this.line_chart.is_allow_single_selection
      }
      return extra_data
    }
  },
  methods: {
    ...mapActions(['updateCurrentAnswer']),
    matchAnswers(){
      let is_correct = false;
      let total_points = this.user_selectable_coord.length;
      let matched_points = 0;
      if(this.user_selectable_coord.length == this.line_chart.selectable_answers.length){
        for(let match of this.line_chart.selectable_answers){
          for(let point of this.user_selectable_coord){
            if((point.x == match.x) && (point.y == match.y)){
              matched_points = matched_points + 1;
            }
          }
        }

        if(total_points == matched_points){
          is_correct = true;
        }
      }
      this.updateCurrentAnswer({key : "line_chart", value : is_correct})
    },
    receiveUserCoord(vals){
      if(this.line_chart.is_allow_single_selection){
        this.user_selectable_coord = []  
      }
      this.user_selectable_coord.push(vals)
      this.matchAnswers()
    }
  },
};
</script>

<style scoped></style>
